<template>
	<div class="cont-box">
		<div class="title"></div>
		<div class="cont">
			<div class="cont-t">
				<div class="cont-t-l">项目人员组织图</div>
				<div class="cont-t-r">
					<div class="btn" v-if="tableDataEnd.length!=0" @click="download">下载</div>
					<div class="btn" @click="addOpen">添加</div>
					<div class="btn xx" v-if="tableDataEnd.length!=0" @click="handleDelete">删除</div>
				</div>
			</div>
			<div class="cont-b">
				<div class="cont-b-t">
					<img style="width:100%;height:69vh" v-for="item in tableDataEnd" :src="httpCtx+item.fileUrl" alt="">
					<div class="text" v-if="tableDataEnd.length==0">
						暂无图片
					</div>
				</div>
				<div class="cont-b-b">
					<el-pagination
						
						@current-change="handleCurrentChange"
						:current-page.sync="pageNum"
						:page-size="pageSize"
						layout="total, prev, pager, next"
						:total="total">
					</el-pagination>
					<el-dialog :title="diaTitle" :visible.sync="addFormVisible" center :append-to-body="true" :lock-scroll="false"
      width="30%">
      <el-form :model="addForm" ref="addForm" label-width="150px" label-position="right" class="teamPage"
       >
        <el-form-item label="上传文件:" prop="managerTel">
          <el-upload class="upload-demo" v-bind:action="uploadUrl" :headers="uploadHead"
            :data={type:245,projectId:groupId} :show-file-list="false" :on-success="fileSuccess">
            <!-- <el-button size="small" style="background: #285bd0;" type="primary" class="primary">点击上传</el-button> -->
            <i v-if="!addForm.fileUrl" class="el-icon-plus avatar-uploader-icon"></i>
            <!-- <img v-if="scope.row.fileFormat=='0'" src="../../assets/image/office/undefined.png" style="width:5vh;height:5vh;"  />
                      <img v-else-if="scope.row.fileFormat=='1'" src="../../assets/image/office/word.png" style="width:5vh;height:5vh;" />
                      <img v-else-if="scope.row.fileFormat=='2'" src="../../assets/image/office/excel.png" style="width:5vh;height:5vh;" />
                      <img v-else-if="scope.row.fileFormat=='3'" src="../../assets/image/office/pdf.png" style="width:5vh;height:5vh;" />
                      <img v-else-if="scope.row.fileFormat=='4'" src="../../assets/image/office/photo.png" style="width:5vh;height:5vh;" /> -->
            <div style="display: flex;justify-content: space-between;align-items: center;">
              <img v-if="addForm.fileUrl" src="../../assets/image/fileicon.png" style="width:5vh;height:5vh;" />
              <span v-if="addForm.fileUrl">{{addForm.fileName}}</span>
            </div>

          </el-upload>
        </el-form-item>
        <!-- <el-form-item label="排序:" prop="sort">
          <el-input v-model="addForm.sort" autocomplete="off" style="width:220px"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="提交人">
          <el-input v-model="addForm.createBy" placeholder="请输入内容" autocomplete="off" style="width:220px"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="备注：">
          <el-input v-model="addForm.remark" type="textarea" placeholder="请输入内容" autocomplete="off" style="width:220px"
            :rows="16"></el-input>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumbitAddRow">确 定</el-button>
      </div>
    </el-dialog>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import myHttp from '../../untils/port'
	import base from '../../untils/base'
	import unit from '../../untils/util'
	import util from '../../untils/util'
	export default {
			data() {
				return {
					total: 0,
					pageSize:1,
					pageNum:1,
					tableDataEnd:[],
					httpCtx:base.httpCtx,
					addFormVisible:false,
					 uploadUrl: base.url + "/upload/uploadFile",//上传地址
					uploadHead: {  //上传接口header
						accessToken: this.$store.state.token
					},
					rules: {
						filesName: [
							{ required: true, message: '请上传图片', trigger: 'blur' }
						],
					},
					diaTitle: '添加',
						addForm: {
						id: '',
						fileName: '',
						fileSize: '',
						fileType: '',
						fileUrl: '',
						remark: '',
						sort: '',
						createBy: '',
						groupId:''
					},
				}
			},
			mounted(){
				this.findProjectFileList()
				this.groupId = util.session.get('groupId')
			},
			methods:{
				download(){
        let token = util.session.get('token')
        window.open(myHttp.downloadFileDj+'?accessToken='+token+'&fileUrl='+base.httpCtx+this.row.fileUrl+'&fileName='+this.row.fileName)
      },
				sumbitAddRow(){
					let that = this
					if(this.addForm.fileUrl==""){
						that.$message.error('请上传文件！')
						return
					}
					myHttp.addProjectFile(that.addForm).then(function (resp) {
						if (resp.data.code == '200') {
							that.$message.success('添加成功')
							that.addFormVisible = false
							that.findProjectFileList()
						} else {
							that.$message.error(resp.data.msg)
						}
					})
				},
				fileSuccess(res, file, opt) {
        var that = this
        if (res.code == 200) {
          console.log(res)
          console.log(file)
          this.addForm.fileType = '25',
            this.addForm.fileName = file.name,
            this.addForm.fileUrl = res.data.fileUrl,
            this.addForm.fileSize = res.data.fileSize,
            this.addForm.projectId = unit.session.get('groupId')
        } else {
          this.$message.error(res.msg);
        }

      },
				addOpen(){
					this.addFormVisible=true
						this.addForm = {
						fileId: '',
						fileName: '',
						fileSize: '',
						fileType: '',
						fileUrl: '',
						remark: '',
						sort: '',
						createBy: ''
					}
					this.diaTitle = '添加'
				},
				handleDelete(){
					var that = this
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          myHttp.deleteProjectFile({
            fileId: that.row.fileId,
            // updateBy: util.session.get('user').id
          }).then(function (resp) {
            if (resp.data.code == '200') {
							that.pageNum = 1
							that.findProjectFileList()
              that.$message({
                type: 'success',
                message: '删除成功!'
              })
            } else {
              that.$message.error(resp.data.msg)
            }
          })
        }).catch(err => { })
				},
				findProjectFileList(){
					myHttp.findProjectFileList({
						fileType: '25',
						projectId: unit.session.get('groupId'),
						pageNum: this.pageNum,
						pageSize: this.pageSize,
					}).then(res=>{
						if(res.data.code==200){
							var list = res.data.data.list || []
							this.total=res.data.data.total
							this.tableDataEnd=list
							if(this.tableDataEnd.length!=0){
								this.row = this.tableDataEnd[0]
							}
						}
					})
				},
				handleCurrentChange(val){
					this.pageNum=val
					this.findProjectFileList()
				}
			}
	}
</script>

<style  scoped>
.cont-box{
	width: 100%;
	height: 100%;
	padding: 0 1.25vw .5208vw .4167vw;
}
.title{
	height: 4vh;
}
.cont{
	overflow: hidden;
	width: 100%;
	height: calc(100% - 4vh);
	border-radius: .3125vw;
background: #FFFFFF;
box-shadow: 5px 4px 10px -2px rgba(0, 0, 0, 0.25);
}
.cont-t{
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0 .4167vw 0 .8333vw;
	height: 5.6vh;
	border-bottom: 2px solid #ECF0F5;
}
.cont-t-l{
	font-family: MicrosoftYaHei;
font-size: .8333vw;
font-weight: normal;
letter-spacing: 0em;
color: #909399;
}
.cont-t-r{
	display: flex;
}
.btn{
	margin-left:.4167vw ;
	padding: .3729vw 1.0938vw;
	border-radius: 2px;
background: #409EFF;
font-family: MicrosoftYaHei;
font-size: .7292vw;
font-weight: normal;
letter-spacing: 0em;
color: #FFFFFF;
}
.btn:hover{
	opacity: 0.7;
	cursor: pointer;
}
.cont-b{
	height: calc(100% - 5.6vh);
	display: flex;
	flex-direction: column;
}
.cont-b-t{
	flex:1;
	padding: 1.0417vw;
}
.el-pagination{
	border-radius: 0px 0px 6px 6px;
background: #FFFFFF;
box-shadow: 0px -10px 21px 0px rgba(225, 225, 225, 0.3);
}
.xx{
	background-color: #f00;
}
.text{
	margin-top: 20vh;
}
</style>